import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { RouterModule } from '@angular/router';
import { NotAuthGuard } from '@cutting/main/shared/guards/not-auth.guard';
import { FuseSharedModule } from '@fuse/shared.module';

import { FuseForgotPasswordComponent } from './forgot-password.component';
import { ForgotPasswordService } from './forgot-password.service';

const routes = [
  {
    path: 'client/auth/forgot-password',
    component: FuseForgotPasswordComponent,
    canActivate: [NotAuthGuard],
  },
];

@NgModule({
  declarations: [FuseForgotPasswordComponent],
  imports: [
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    FuseSharedModule,
    MatSnackBarModule,
    RouterModule.forChild(routes),
  ],
  providers: [ForgotPasswordService, NotAuthGuard],
})
export class ForgotPasswordModule {}
